import { render } from "./ImageFormView.vue?vue&type=template&id=61f19b80&scoped=true"
import script from "./ImageFormView.vue?vue&type=script&lang=js"
export * from "./ImageFormView.vue?vue&type=script&lang=js"

import "./ImageFormView.vue?vue&type=style&index=0&id=61f19b80&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f19b80"]])

export default __exports__